import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CityGetAll } from '../../service/CityService';

export default function CityList() {
  const {
    isLoading, setIsLoading,
    setAppError, setAppErrorTitle, setAppErrorMessage, setAppErrorMode
  } = useGlobalContext();

  const [citys, setCitys] = useState([]);
  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const fetchCityList = async (currentPage = page) => {
    try {
      setIsLoading(true);
      const response = await CityGetAll(currentPage, limit, keyword);
      setCitys(response.cities || []);
      setTotalPages(response.totalPages || 1);
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    fetchCityList(page); // Pass current page
  }, [page]);

  const handleSearch = () => {
    setPage(1);
    fetchCityList(1); // Reset to first page on search
  };

  return (
    <>
      <Helmet>
        <title>City List | {config.appName}</title>
      </Helmet>
      <div className='container'>
        <div className='page'>
          <div className='page-heading'>
            <h1>City List</h1>
            <span><Link to="/">Dashboard</Link> / City List</span>
          </div>
          <div className='page-content'>
            <div className="portal">
              <div className='portal-body'>
                <form>
                  <div className='row'>
                    <div className='col-lg-3 col-md-3 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label htmlFor="keyword" className="form-label">Keyword</label>
                        <div className="input-group mb-3">
                          <input
                            type="text"
                            className="form-control"
                            value={keyword}
                            onChange={(e) => setKeyword(e.target.value)}
                          />
                          <button
                            className="btn btn-outline-secondary"
                            type="button"
                            id="button-addon1"
                            onClick={handleSearch}
                          >
                            <FontAwesomeIcon icon="fa-solid fa-search" />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className='col-lg-3 col-md-3 col-sm-6 col-12'>
                      <div className="p-2">
                        <div className="input-group p-4">
                          <Link className="btn btn-success" to="/setting/add">
                            <FontAwesomeIcon icon="fa-solid fa-plus" /> Add City
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>

                <div className='table-content'>
                  <table className='table table-bordered table-condensed'>
                    <thead>
                      <tr>
                        <th> Sl.no</th>
                        <th>State</th>
                        <th>Name</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {citys && citys.length > 0 ? (
                        citys.map((city, index) => (
                          <tr key={city.id}>
                            <td>{(page - 1) * limit + index + 1}</td>
                            <td>{city.state.name}</td>
                            <td>{city.name}</td>
                            <td>{city.status}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center">No cities found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination Controls */}
                <div className="pagination-buttons">
                  {page > 1 && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.max(prev - 1, 1))}
                    >
                      Prev
                    </button>
                  )}

                  <span className="align-self-center px-3">Page {page} of {totalPages}</span>

                  {page < totalPages && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => setPage(prev => Math.min(prev + 1, totalPages))}
                    >
                      Next
                    </button>
                  )}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
